import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton } from '@ui/button';
import { ResponsiveImage, StickyNav } from '@web/molecules';
import { ButtonLink } from '@web/atoms';
import {
  BackColumn,
  ButtonContainer,
  ContentConatiner,
  ContinueColumn,
  ContinueColumnWithImage,
  ImageContainer,
  SkipColumn,
  StyledCheckoutBar,
  StyledHeadline,
  TextContainer,
} from './styles';
import { Pricing } from './Pricing';

export const CheckoutBar = ({
  shown,
  ctaText,
  price,
  discountedPrice,
  message,
  period,
  isSubmitDisabled = false,
  isBackButtonDisabled,
  onBackButtonClick,
  onSkipButtonClick,
  isSubmitting = false,
  headline,
  subheadline,
  savePercentText,
  relativePosition = false,
  buttonVariant = 'yellow',
  skipButtonVariant = 'link',
  centerSkip = false,
  top = false,
  topPosition = 0,
  withImage = false,
  image,
}) => {
  return (
    <StickyNav
      shown={shown}
      relativePosition={relativePosition}
      top={top}
      topPosition={topPosition}
    >
      <StyledCheckoutBar>
        <ButtonContainer $withImage={withImage}>
          {onBackButtonClick && (
            <BackColumn>
              <IconButton
                aria-label="go to previous step"
                icon={{
                  iconName: 'arrow-left',
                  size: '24px',
                  alt: 'back',
                  id: 'prev_step_checkout',
                }}
                disabled={isBackButtonDisabled}
                onClick={onBackButtonClick}
                type="button"
                variant={buttonVariant}
              />
            </BackColumn>
          )}
          {onSkipButtonClick && skipButtonVariant === 'button' && (
            <SkipColumn $withButton={true}>
              <Button
                type="button"
                fullWidth
                variant={'secondary'}
                onClick={onSkipButtonClick}
              >
                {'Skip'}
              </Button>
            </SkipColumn>
          )}
          {!withImage ? (
            <ContinueColumn $centerSkip={centerSkip} $hasPrice={price}>
              {headline && <StyledHeadline>{headline}</StyledHeadline>}
              {subheadline}
              {
                // TODO(James) refactor this into a `pricing` object
                <Pricing
                  price={price}
                  discountedPrice={discountedPrice}
                  period={period}
                  message={message}
                  savePercent={savePercentText}
                />
              }
              <Button
                type="button"
                disabled={isSubmitDisabled}
                fullWidth
                variant={buttonVariant}
                isLoading={isSubmitting}
              >
                {ctaText}
              </Button>
              {onSkipButtonClick && skipButtonVariant === 'link' && (
                <SkipColumn $withButton={false}>
                  <ButtonLink onClick={onSkipButtonClick}>Skip</ButtonLink>
                </SkipColumn>
              )}
            </ContinueColumn>
          ) : (
            <ContinueColumnWithImage $centerSkip={centerSkip} $hasPrice={price}>
              <ContentConatiner>
                {image && (
                  <ImageContainer>
                    <ResponsiveImage src={image.src} height={70} width={70} />
                  </ImageContainer>
                )}
                <TextContainer>
                  {headline && <StyledHeadline>{headline}</StyledHeadline>}
                  {subheadline}
                  {
                    // TODO(James) refactor this into a `pricing` object
                    <Pricing
                      price={price}
                      discountedPrice={discountedPrice}
                      discountedPriceColor={'#CAB5AA'}
                      period={period}
                      message={message}
                      savePercent={savePercentText}
                    />
                  }
                </TextContainer>
              </ContentConatiner>

              <Button
                type="button"
                disabled={isSubmitDisabled}
                variant={buttonVariant}
                isLoading={isSubmitting}
                percentWidthMobile={35}
                horizontalPadding={16}
                height={'85%'}
              >
                {ctaText}
              </Button>
              {onSkipButtonClick && skipButtonVariant === 'link' && (
                <SkipColumn $withButton={false}>
                  <ButtonLink onClick={onSkipButtonClick}>Skip</ButtonLink>
                </SkipColumn>
              )}
            </ContinueColumnWithImage>
          )}
        </ButtonContainer>
      </StyledCheckoutBar>
    </StickyNav>
  );
};

CheckoutBar.displayName = 'CheckoutBar';

CheckoutBar.propTypes = {
  shown: PropTypes.bool.isRequired,
  ctaText: PropTypes.node.isRequired,
  price: PropTypes.string,
  discountedPrice: PropTypes.string,
  period: PropTypes.string,
  message: PropTypes.string,
  savePercentText: PropTypes.string,
  isSubmitDisabled: PropTypes.bool,
  isBackButtonDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
  onSkipButtonClick: PropTypes.func,
  headline: PropTypes.node,
  subheadline: PropTypes.node,
  relativePosition: PropTypes.bool,
  buttonVariant: PropTypes.string,
  centerSkip: PropTypes.bool,
  top: PropTypes.bool,
  topPosition: PropTypes.number,
  withImage: PropTypes.bool,
  image: PropTypes.object,
};
